export default {
  baseStyle: {
    control: {
      borderRadius: "md",
      // _checked: {
      //   // bg: "text.dark",
      //   borderColor: "text.dark",
      //   _hover: {
      //     bg: "text.dark",
      //     borderColor: "primary.dark",
      //   },
      // },
      _indeterminate: {
        bg: "text.dark",
        borderColor: "text.dark",
        _hover: {
          bg: "text.dark",
          borderColor: "primary.dark",
        },
      },
      _focus: {
        boxShadow: "none",
      },
    },
    icon: {
      color: "primary.dark",
    },
  },
  variants: {
    blueCheckBox: {
      borderRadius: "md",
      control: {
        backgroundColor: "#F3F5F7",
        borderWidth: "1px", 
        _checked: {
          backgroundColor: "checkBoxBlue", 
          borderColor: "checkBoxBlue", 
        },
        _hover: {
          backgroundColor: "checkBoxBlue",
          borderColor: "checkBoxBlue", 
        },
      },
      icon: {
        _checked: {
          color: "white",
        },
      },
    },
    blackCheckBox: {
      control: {
        borderRadius: "md",
        _checked: {
          bg: "text.dark",
          borderColor: "text.dark",
          _hover: {
            bg: "text.dark",
            borderColor: "primary.dark",
          },
        },
        _indeterminate: {
          bg: "text.dark",
          borderColor: "text.dark",
          _hover: {
            bg: "text.dark",
            borderColor: "primary.dark",
          },
        },
        _focus: {
          boxShadow: "none",
        },
      },
      icon: {
        color: "primary.dark",
      },
    }
  }
}
